import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExcluirAtividade = ({ dadosOs, atividade }) => {
  const {
    request: excluirRequest,
    data: excluirData,
    errors: excluirErrors,
    isLoading: excluirIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (excluirIsLoading) return;

    if (!excluirData && !excluirErrors) return;

    if (excluirData) {
      toast.success("Atividade excluída com sucesso!");
      window.location.reload();
    }
  }, [excluirData, excluirErrors, excluirIsLoading]);

  const excluirAtividade = () => {
    excluirRequest(apiRoutes.fiscalizacao.ordemservico.excluirAtividade, {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialComunicado: dadosOs.sequencialComunicado,
      sequencialAtividade: atividade.sequencialAtividade,
      tipoAuto: null,
    });
  };

  return { excluirAtividade };
};

export default useExcluirAtividade;
